import { render, staticRenderFns } from "./JoinLink.vue?vue&type=template&id=629dae5f&scoped=true&"
import script from "./JoinLink.vue?vue&type=script&lang=js&"
export * from "./JoinLink.vue?vue&type=script&lang=js&"
import style0 from "./JoinLink.vue?vue&type=style&index=0&id=629dae5f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629dae5f",
  null
  
)

export default component.exports